/* PACKAGES */
import { motion } from "framer-motion";

/* ANIMATION */
import { animation } from "config";

const HomeFeatures = () => {
  return (
    <motion.div variants={animation} className="pt-10 xl:pt-20 lg:pt-20">
      {/* HEADING */}
      <div className="p-0">
        <div className="container">
          <h5 className="text-lg font-source font-medium text-logo uppercase">
            Empower Your Alumni
          </h5>
          <div className="mt-3">
            <h2 className="text-2xl xl:text-3xl lg:text-3xl font-roundo font-bold text-black">
              Powerful Features Built for Lasting Alumni Engagement
            </h2>
            <h5 className="text-lg font-source font-normal text-greyText w-full xl:w-3/5 lg:w-3/5 leading-relaxed mt-2">
              From networking and mentorship to events and career support,
              Alumni Connection Hub offers a full suite of tools designed to
              help universities create meaningful connections and vibrant alumni
              communities.
            </h5>
          </div>
        </div>
      </div>

      {/* CUSTOM LANDING PAGE */}
      <div className="py-10 xl:py-20 lg:py-20">
        <div className="container">
          <div className="grid grid-cols-1 xl:grid-cols-2 lg:grid-cols-2 gap-y-10 xl:gap-20 lg:gap-20 items-center">
            {/* LEFT SECTION */}
            <div className="col-span-1">
              <div className="w-full h-[25vh] xl:h-[45vh] lg:h-[45vh] bg-gradient-to-br border border-logo/20 from-logo/50 to-white shadow-inner rounded-2xl p-5 xl:p-10 lg:p-10">
                <img
                  src={require("../../assets/images/custom-landing-page.png")}
                  className="w-full h-full object-cover rounded-xl shadow"
                  alt="Custom Landing Page"
                />
              </div>
            </div>

            {/* RIGHT SECTION */}
            <div className="col-span-1">
              <h5 className="text-lg font-source font-semibold text-logo uppercase">
                CUSTOM LANDING PAGE
              </h5>
              <div className="mt-3">
                <h3 className="text-2xl font-roundo font-bold text-black">
                  Personalized Welcome for Every Alumnus
                </h3>
                <div className="mt-5">
                  <h5 className="text-lg font-source font-normal text-greyText">
                    With Alumni Connection Hub’s Custom Landing Page feature,
                    your institution can design a personalized and visually
                    engaging entry point for your alumni. Reflect your
                    university’s identity with your logo, colors, and
                    messaging—all tailored to foster a sense of belonging from
                    the first click. Whether it’s highlighting success stories,
                    promoting upcoming events, or showcasing alumni
                    achievements, your landing page becomes the digital front
                    door to your alumni network.
                  </h5>
                  <h5 className="mt-3 text-lg font-source font-normal text-greyText">
                    This page is fully customizable and mobile-friendly,
                    allowing you to update content effortlessly as your
                    community evolves. Make a lasting first impression while
                    guiding alumni to explore directories, job boards,
                    mentorship programs, and more—all in one seamless
                    experience.
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* NOTICEBOARD */}
      <div className="py-10 xl:py-20 lg:py-20 bg-[#F5F5F5]">
        <div className="container">
          <div className="grid grid-cols-1 xl:grid-cols-2 lg:grid-cols-2 gap-y-10 xl:gap-20 lg:gap-20 items-center">
            {/* LEFT SECTION */}
            <div className="col-span-1 order-2 xl:order-1 lg:order-1">
              <h5 className="text-lg font-source font-semibold text-logo uppercase">
                Noticeboard
              </h5>
              <div className="mt-3">
                <h3 className="text-2xl font-roundo font-bold text-black">
                  Keep Your Alumni Informed with Digital Noticeboard
                </h3>
                <div className="mt-5">
                  <h5 className="text-lg font-source font-normal text-greyText">
                    Stay connected with your alumni community through a
                    centralized Noticeboard that brings important updates,
                    announcements, and opportunities to their fingertips.
                    Whether it’s campus news, reunion dates, fundraising
                    campaigns, or job openings, the Noticeboard ensures your
                    message reaches every alumnus in real-time.
                  </h5>
                  <h5 className="mt-3 text-lg font-source font-normal text-greyText">
                    Designed to be easy to manage and even easier to read, the
                    Noticeboard keeps your communication organized, timely, and
                    relevant. Pin urgent posts, schedule future updates, and
                    maintain a consistent flow of information—all while
                    strengthening alumni engagement and keeping them actively
                    involved with your institution.
                  </h5>
                </div>
              </div>
            </div>

            {/* RIGHT SECTION */}
            <div className="col-span-1 order-1 xl:order-2 lg:order-2">
              <div className="w-full h-[25vh] xl:h-[45vh] lg:h-[45vh] bg-gradient-to-br border border-logo/20 from-logo/50 to-white shadow-inner rounded-2xl p-5 xl:p-10 lg:p-10">
                <img
                  src={require("../../assets/images/noticeboard.png")}
                  className="w-full h-full object-cover rounded-xl shadow"
                  alt="Noticeboard"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* EVENTS */}
      <div className="py-10 xl:py-20 lg:py-20">
        <div className="container">
          <div className="grid grid-cols-1 xl:grid-cols-2 lg:grid-cols-2 gap-y-10 xl:gap-20 lg:gap-20 items-center">
            {/* LEFT SECTION */}
            <div className="col-span-1">
              <div className="w-full h-[25vh] xl:h-[45vh] lg:h-[45vh] bg-gradient-to-br border border-logo/20 from-logo/50 to-white shadow-inner rounded-2xl p-5 xl:p-10 lg:p-10">
                <img
                  src={require("../../assets/images/events.png")}
                  className="w-full h-full object-cover rounded-xl shadow"
                  alt="Events"
                />
              </div>
            </div>

            {/* RIGHT SECTION */}
            <div className="col-span-1">
              <h5 className="text-lg font-source font-semibold text-logo uppercase">
                Events
              </h5>
              <div className="mt-3">
                <h3 className="text-2xl font-roundo font-bold text-black">
                  Bring Your Alumni Together with Seamless Event Management
                </h3>
                <div className="mt-5">
                  <h5 className="text-lg font-source font-normal text-greyText">
                    Reignite the spirit of campus life by hosting meaningful
                    events through our all-in-one Events feature. Whether it's
                    reunions, networking meetups, webinars, or fundraising
                    galas, Alumni Connection Hub makes it easy to create,
                    promote, and manage events that keep alumni connected and
                    engaged.
                  </h5>
                  <h5 className="mt-3 text-lg font-source font-normal text-greyText">
                    With built-in RSVP tracking, automated reminders, and
                    attendee insights, organizing events becomes effortless and
                    impactful. You can highlight speakers, share agendas, and
                    even collect feedback—all from one platform. Strengthen your
                    alumni bond by making every event an opportunity to
                    reconnect, celebrate, and grow your community.
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* YEARBOOK */}
      <div className="py-10 xl:py-20 lg:py-20 bg-[#F5F5F5]">
        <div className="container">
          <div className="grid grid-cols-1 xl:grid-cols-2 lg:grid-cols-2 gap-y-10 xl:gap-20 lg:gap-20 items-center">
            {/* LEFT SECTION */}
            <div className="col-span-1 order-2 xl:order-1 lg:order-1">
              <h5 className="text-lg font-source font-semibold text-logo uppercase">
                Yearbook
              </h5>
              <div className="mt-3">
                <h3 className="text-2xl font-roundo font-bold text-black">
                  Celebrate Memories with a Digital, Interactive Yearbook
                </h3>
                <div className="mt-5">
                  <h5 className="text-lg font-source font-normal text-greyText">
                    The Yearbook feature brings your alumni network to
                    life—organized, accessible, and beautifully displayed by
                    graduation year and batch. It’s more than just a directory;
                    it’s a digital time capsule that lets alumni reconnect with
                    classmates, browse familiar faces, and celebrate the shared
                    history that unites them.
                  </h5>
                  <h5 className="mt-3 text-lg font-source font-normal text-greyText">
                    Each alumnus can update their profile with photos, career
                    milestones, and contact details, making it easier than ever
                    to rekindle old friendships and forge new ones. Whether they
                    graduated last year or decades ago, every member of your
                    alumni community has a place to belong—and be found.
                  </h5>
                </div>
              </div>
            </div>

            {/* RIGHT SECTION */}
            <div className="col-span-1 order-1 xl:order-2 lg:order-2">
              <div className="w-full h-[25vh] xl:h-[45vh] lg:h-[45vh] bg-gradient-to-br border border-logo/20 from-logo/50 to-white shadow-inner rounded-2xl p-5 xl:p-10 lg:p-10">
                <img
                  src={require("../../assets/images/yearbook.png")}
                  className="w-full h-full object-cover rounded-xl shadow"
                  alt="Yearbook"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CAREERS */}
      <div className="py-10 xl:py-20 lg:py-20">
        <div className="container">
          <div className="grid grid-cols-1 xl:grid-cols-2 lg:grid-cols-2 gap-y-10 xl:gap-20 lg:gap-20 items-center">
            {/* LEFT SECTION */}
            <div className="col-span-1">
              <div className="w-full h-[25vh] xl:h-[45vh] lg:h-[45vh] bg-gradient-to-br border border-logo/20 from-logo/50 to-white shadow-inner rounded-2xl p-5 xl:p-10 lg:p-10">
                <img
                  src={require("../../assets/images/careers.png")}
                  className="w-full h-full object-cover rounded-xl shadow"
                  alt="Careers"
                />
              </div>
            </div>

            {/* RIGHT SECTION */}
            <div className="col-span-1">
              <h5 className="text-lg font-source font-semibold text-logo uppercase">
                Careers
              </h5>
              <div className="mt-3">
                <h3 className="text-2xl font-roundo font-bold text-black">
                  Open Doors with Alumni-Driven Career Opportunities
                </h3>
                <div className="mt-5">
                  <h5 className="text-lg font-source font-normal text-greyText">
                    Empower your alumni community to grow professionally through
                    our Careers feature—where alumni can post, discover, and
                    share job opportunities directly within the platform. This
                    peer-to-peer job board turns your alumni network into a
                    powerful career ecosystem, encouraging support, mentorship,
                    and professional growth from within.
                  </h5>
                  <h5 className="mt-3 text-lg font-source font-normal text-greyText">
                    Institutions can also spotlight career fairs, internships,
                    and hiring events, while alumni recruiters can reach talent
                    who already share their academic roots. It's not just about
                    job listings—it's about creating meaningful opportunities
                    backed by trust, shared experience, and a spirit of giving
                    back.
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default HomeFeatures;
